import GalleryGrid from './GalleryGrid';
import GalleryMasonry from './GalleryMasonry';
import GalleryEditorial from './GalleryEditorial';
import GalleryDarkEditorial from './GalleryDarkEditorial';

const VARIANTS = {
  'gallery-grid': GalleryGrid,
  'gallery-masonry': GalleryMasonry,
  'gallery-editorial': GalleryEditorial,
  'gallery-dark-editorial': GalleryDarkEditorial,
};

export default function GallerySection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || GalleryGrid;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
